import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Brain, Zap, Shield, Target, Lightbulb, Mic } from 'lucide-react';
import './Features.css';

// 只保留精选的核心特点
const featuresData = [
  {
    icon: Target,
    title: '99% 高精度转写',
    description: '方言准、中英混用准、专业术语准、识别对话人准',
  },
  {
    icon: Brain,
    title: '母语级实时翻译',
    description: '母语级别，不闹笑话',
  },
  {
    icon: Lightbulb,
    title: '真正的总结',
    description: '观点先行、洞见突出，告别压缩式"总结"',
  },
  {
    icon: Mic,
    title: '全场景录音',
    description: '5 米环境录音、手机通话录音，随需切换',
  },
  {
    icon: Zap,
    title: '一键操作',
    description: '轻按 2 秒，录音开启，自动生成纪要',
  },
  {
    icon: Shield,
    title: '微信打开阅读，方便快捷',
    description: '音频、文件分享不受手机、操作系统和软件限制',
  },
];

const Features = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <section className="features" id="features" ref={ref}>
      <div className="container">
        <motion.div
          className="features-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="features-title">产品核心特点</h2>
        </motion.div>

        <motion.div
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {featuresData.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <motion.div
                key={index}
                className="feature-card"
                variants={itemVariants}
                whileHover={{ 
                  y: -10,
                  transition: { duration: 0.3 }
                }}
              >
                <div className="feature-icon">
                  <IconComponent size={24} />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <div className="feature-hover-effect"></div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>

      {/* 背景装饰 */}
      <div className="features-background">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>
    </section>
  );
};

export default Features; 